import React, { useState, useEffect, useContext } from 'react';
import { StyleSheet, Text, View, Image, Button, TouchableOpacity, TouchableWithoutFeedback, FlatList } from 'react-native';
import MinionFilters from './filters/MinionFilters'
import BattlegroundFilters from './filters/BattlegroundFilters'
import SoundDivider from './SoundDivider';
import Card from './Card';
import FlatListItemSeparator from './FlatListItemSeparator';
import InfoModal from './InfoModal'
import { NavigationContainer, useScrollToTop, useIsFocused } from '@react-navigation/native';
import { Toolbar } from 'react-native-material-ui';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import ToolbarTitle from './ToolbarTitle'
import VolumeSlider from './VolumeSlider'
import CardListItem from './CardListItem'
import DeviceContext from './DeviceContext'
import {generalCards, heroCards, bgCards, duelsCards, tokenIDs, duelsIDs,
  battlegroundToken, battlegroundHeroSpecific, battlegroundFlavor, battlegroundRetired,
  nonCoreCardVersions} from './HelperFunctions'

const CardListTab = ( { route, navigation, state }) => {

  // Context variables.
  const deviceType = useContext(DeviceContext)

  // State variables
  const [cardDisplayed, setCardDisplayed] = useState('none')
  const [card, setCard] = useState([])
  const [myCardData, setMyCardData] = useState([])
  const [cards, setCards] = useState([])
  const [loadLimit, setLoadLimit] = useState(100)
  const [showFooter, setShowFooter] = useState(true)
  const [toolbarVisibilities, setToolbarVisilities] = useState({'filterMenu': 'hidden', 'infoModal': 'hidden', 'volumeSlider': 'hidden'})

  // Card filter variables.
  const cardFilterDict = {
    'nonCollectible': useState(false),
    'types': useState({'MINION': true, 'HERO': true, 'SPELL': false, 'WEAPON': false}),
    'rarity': useState({undefined: true, 'FREE': true, 'COMMON': true, 'RARE': true, 'EPIC': true, 'LEGENDARY': true})
  }

  // Battlegrounds filter variables.
  const bgFilterDict = {
    'bgTiers': useState({1: true, 2: true, 3: true, 4: true, 5: true, 6: true}),
    'bgTribes': useState({'Beast': true, 'Demon': true, 'Dragon': true, 'Mech': true, 'Murloc': true,'Pirate': true,'Elemental': true,'Neutral': true}),
    'bgTokens': useState(false),
    'bgHeroSpecific': useState(false),
    'bgRetired': useState(false)
  }

  // Used to move to top of card list on nav to tab.
  const flatListRef = React.useRef()
  useScrollToTop(flatListRef)

  var {cardSet} = route.params
  const typeFilter = route.name
  var {cardID} = route.params

  useEffect(() => {
    if(cardID != '' && cardID != undefined)
      setCardDisplayed('')
    else
      setCardDisplayed('none')
  })

  const filterCards = (searchCriteria, applyLoadLimit, increaseLoadLimit,
    newCardFilterDict, newBGFilterDict) => {
    var filteredData

    if (typeFilter == 'Cards') {
      // If no newCardFilterDict is passed to the function, assume default filters of no nonCollectible.
      if(newCardFilterDict == null) {
        filteredData = generalCards.filter(x =>
          cardFilterDict['types'][0][x.type]
          && cardFilterDict['rarity'][0][(x.rarity == undefined) ? 'FREE' : x.rarity]
          && (x.collectible == true || tokenIDs.includes((cardFilterDict['nonCollectible'][0]) ? x.id : 'N/A'))
          && (x.set == cardSet 
            || (['all','DARKMOON_RACES','WAILING_CAVERNS','DEADMINES','ONYXIA','THRONE_TIDES','MAW_AND_DISORDER','RETURN_TO_NAXXRAMAS','AUDIOPOCALYPSE','YOGG','DEEPHOLM'].includes(cardSet) && !nonCoreCardVersions().includes(x.id))
            || (cardSet == 'CORE' && x.set == undefined && x.id.toString().slice(0,3) == 'RLK'))
          && ((searchCriteria != "" && searchCriteria != null) ? (x.name.toUpperCase()).includes(searchCriteria.toUpperCase()) : 1 == 1)
          && (x.set != 'HERO_SKINS')
          //&& (x.set == cardSet || (cardSet == 'all' && !nonCoreCardVersions().includes(x.id)))
      )}
      else {
        filteredData = generalCards.filter(x =>
          newCardFilterDict['types'][x.type]
          && newCardFilterDict['rarity'][(x.rarity == undefined) ? 'FREE' : x.rarity]
          && (x.collectible == true || tokenIDs.includes((newCardFilterDict['nonCollectible']) ? x.id : 'N/A'))
          && (x.set == cardSet 
            || (['all','DARKMOON_RACES','WAILING_CAVERNS','DEADMINES','ONYXIA','THRONE_TIDES','MAW_AND_DISORDER','RETURN_TO_NAXXRAMAS','AUDIOPOCALYPSE','YOGG','DEEPHOLM'].includes(cardSet) && !nonCoreCardVersions().includes(x.id))
            || (cardSet == 'CORE' && x.set == undefined && x.id.toString().slice(0,3) == 'RLK'))
          && ((searchCriteria != "" && searchCriteria != null) ? (x.name.toUpperCase()).includes(searchCriteria.toUpperCase()) : 1 == 1)
          && (x.set != 'HERO_SKINS')
      )}

      // Minisets technically belongs to their base expansion sets, but implement special logic so they can be broken out too.
      if (cardSet == 'DARKMOON_RACES')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'YOP')
      if (cardSet == 'WAILING_CAVERNS')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,2) == 'WC')
      if (cardSet == 'DEADMINES')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'DED')
      if (cardSet == 'ONYXIA')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'ONY')
      if (cardSet == 'THRONE_TIDES')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'TID')
      if (cardSet == 'MAW_AND_DISORDER')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'MAW')
      if (cardSet == 'RETURN_TO_NAXXRAMAS')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'NX2')
      if (cardSet == 'AUDIOPOCALYPSE')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'JAM')                                       
      if (cardSet == 'YOGG')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,3) == 'YOG')         
      if (cardSet == 'DEEPHOLM')
        filteredData = filteredData.filter(x => (x.id).toString().slice(0,4) == 'DEEP')

      if(applyLoadLimit && !increaseLoadLimit) {
        filteredData = filteredData.slice(0, loadLimit)
        setMyCardData(filteredData)
      } else if (increaseLoadLimit) {
        filteredData = filteredData.slice(loadLimit,loadLimit+100)
        setMyCardData(myCardData.concat(filteredData))
      } else {
        setMyCardData(filteredData)
      }
    }

    else if (typeFilter == 'Battlegrounds') {
      // If no newBGFilterDict is passed to the function, assume default filters of no tokens, no retired, no hero-specific cards.
      if (newBGFilterDict == null)
          setMyCardData(bgCards.filter(x =>
            !battlegroundToken(x.id) && !battlegroundRetired(x.id) && !battlegroundHeroSpecific(x.id)
          ))
      else {
        setMyCardData(bgCards.filter(x =>
            (!battlegroundToken(x.id) || newBGFilterDict['bgTokensFilter']) &&
            (battlegroundTechLevel(x) == undefined || newBGFilterDict['bgTierFilter'][(battlegroundTechLevel(x))]) &&
            (!battlegroundHeroSpecific(x.id) || newBGFilterDict['bgHeroSpecificFilter']) &&
            (!battlegroundRetired(x.id) || newBGFilterDict['bgRetiredFilter']) &&
            (newBGFilterDict['bgTribeFilter'][(battlegroundTribe(x.id))]) &&
            ((searchCriteria != "" && searchCriteria != null) ? (x.name.toUpperCase()).includes(searchCriteria.toUpperCase()) : 1 == 1)
      ))}
    }

    else if (typeFilter == 'Duels') {
      setMyCardData(duelsCards.filter(x =>
          ((searchCriteria != "" && searchCriteria != null) ? (x.name.toUpperCase()).includes(searchCriteria.toUpperCase()) : 1 == 1)
    ))}

    else if (typeFilter == 'Heroes') {
      setMyCardData(heroCards.filter(x =>
        ((searchCriteria != "" && searchCriteria != null) ? (x.name.toUpperCase()).includes(searchCriteria.toUpperCase()) : 1 == 1)
    ))}
  }

  function search(criteria) {
    if(criteria != "" && criteria != null) {
      filterCards(criteria, false, false)
      setShowFooter(false)
    }
    else {
      filterCards(null, true, false)
      setShowFooter(true)
    }
  }

  navigation.addListener('tabPress', e => {
    if (typeFilter == 'Cards') {
      cardID = null
      navigation.navigate(
        'Cards',
        {cardSet: 'all'}
      )
    } else if (typeFilter == 'Heroes') {
      filterCards()
      navigation.navigate(
        'Heroes'
      )
      focus()
    } else if (typeFilter == 'Battlegrounds') {
      filterCards()
      navigation.navigate(
        'Battlegrounds'
      )
    }
    focus()
  })

  navigation.addListener('focus', e => {
    focus()
  })

  function focus() {
    goToTop()

    if (typeFilter == 'Cards' && cardSet != 'all') {
      filterCards(null, false, false)

    }
    else if (typeFilter == 'Cards' && cardSet == 'all')
      filterCards(null, true, false)
    else if (['Heroes', 'Battlegrounds', 'Duels'].includes(typeFilter))
      filterCards()

    if (cardID != '') {

      let cardToShow = generalCards.concat(heroCards).find(x => x.id == cardID)    
      if (cardToShow != undefined) {
        showCard(cardToShow)
      }
    }

    else {
      navigation.setParams({
        cardID: ''
      })
    }
  }

  function goToTop() {
    flatListRef.current.scrollToOffset({ animated: true, offset: 0 })
  }

  function showCard(card) {
    setCard(card)
    setCards([card])
    setToolbarVisilities({'filterMenu': 'hidden', 'infoModal': 'hidden', 'volumeSlider': 'hidden'})
    navigation.setParams({
      cardID: card.id
    })
  }

  const returnToPreviousCard = () => {
    setCard(cards[cards.length-2])
    navigation.setParams({
      cardID: cards[cards.length-2].id
    })
    cards.pop()
  }

  const CardListFooter = () => {
    if (typeFilter != 'Cards') {
      return (<></>)
    } else {
      return (
        <>
        {
          (myCardData.length < generalCards.filter(x =>
            cardFilterDict['types'][0][x.type]
            && cardFilterDict['rarity'][0][(x.rarity == undefined) ? 'FREE' : x.rarity]
            && (x.collectible == true || tokenIDs.includes((cardFilterDict['nonCollectible'][0]) ? x.id : 'N/A'))
            && (x.set == cardSet || (cardSet == 'all' && !nonCoreCardVersions().includes(x.id)))).length && showFooter) ?
          <TouchableOpacity style={styles.button} onPress= {() => {
            filterCards(null, true, true)
            setLoadLimit(loadLimit+100)
          }}>
            <Text style={styles.text}>Load More</Text>
          </TouchableOpacity>
          : <></>
        }
        </>
      )
    }
  }

  const FilterMenu = () => {
    if (typeFilter == 'Cards') {
      return (<MinionFilters
        visibility={toolbarVisibilities['filterMenu']}
        filterCards={filterCards}
        cardFiltersHook={cardFilterDict}
        />)
    } else if (typeFilter == 'Battlegrounds') {
      return (<BattlegroundFilters
        visibility={toolbarVisibilities['filterMenu']}
        filterCards={filterCards}
        bgFiltersHook={bgFilterDict}
        />)
    } else
      return (<></>)
  }

  const styles = StyleSheet.create({
    button: {
      alignItems: "center", padding: 10, justifyContent: 'center', backgroundColor: "#2196F3",
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5
    },
    text: {
      alignItems: "center", justifyContent: 'center', color: "white", fontSize: 14,
    }
  })

  return (

      <>
      <Toolbar
          centerElement={<ToolbarTitle/>}
          isSearchActive={false}
          searchable={{
            autoFocus: true,
            placeholder: 'Search',
            onChangeText: (criteria) => { search(criteria) },
            onSearchClosed: () => {
              filterCards(null, true)
              setShowFooter(true)},
            onSearchPressed: () => {
              setToolbarVisilities({'filterMenu': 'hidden', 'infoModal': 'hidden', 'volumeSlider': 'hidden'})
            }
          }}
          rightElement= {
            <>
              <TouchableOpacity style={{paddingTop: 8, paddingRight: 8}} onPress={() => {
                setToolbarVisilities({'filterMenu': 'hidden', 'infoModal': toolbarVisibilities['infoModal'] == 'hidden' ? 'visible' : 'hidden', 'volumeSlider': 'hidden'})
              }}>
                <MaterialCommunityIcons name="information-outline" size={30} color="white" />
              </TouchableOpacity>
              <TouchableOpacity style={{paddingTop: 8, paddingRight: 8}} onPress={() => {
                setToolbarVisilities({'filterMenu': 'hidden', 'infoModal': 'hidden', 'volumeSlider': toolbarVisibilities['volumeSlider'] == 'hidden' ? 'visible' : 'hidden'})
              }}>
                <MaterialCommunityIcons name="volume-high" size={30} color="white" />
              </TouchableOpacity>
              {typeFilter == 'Cards' || typeFilter == 'Battlegrounds' ?
                <TouchableOpacity style={{paddingTop: 8}} onPress={() => {
                  setToolbarVisilities({'filterMenu': toolbarVisibilities['filterMenu'] == 'hidden' ? 'visible' : 'hidden', 'infoModal': 'hidden', 'volumeSlider': 'hidden'})
                  }}>
                <MaterialCommunityIcons name="filter-variant" size={30} color="white" />
              </TouchableOpacity>
            : <></>}

            </>
          }
        />
        <FilterMenu/>
        <VolumeSlider visibility={toolbarVisibilities['volumeSlider']}/>
        <InfoModal closeInfoModal={() => setToolbarVisilities({'filterMenu': 'hidden', 'infoModal': 'hidden', 'volumeSlider': 'hidden'})} infoModalVisibility={toolbarVisibilities['infoModal']}/>
        <View style={{ flex: 1, padding: 8, flexDirection: 'row'}}>
            <View style={{flex: (cardDisplayed == 'none' || deviceType == 'desktop') ? 3 : 0}}>
              <FlatList
              data={myCardData}
              keyExtractor={item => item.id}
              renderItem={({item}) => (<CardListItem item={item} typeFilter={typeFilter} showCard={showCard} />)}
              ItemSeparatorComponent={FlatListItemSeparator}
              ListFooterComponent={CardListFooter}
              ref={flatListRef}
            />
            </View>
            {cardDisplayed == 'none' ? <></> : 
              <View style={{flex: 2, justifyContent:'center', display:cardDisplayed}}>
                 <Card card={card}
                    battlegrounds={(typeFilter == 'Battlegrounds')}
                    openNewCard={(newCardID, addToCardsList=true) => {
                      var newCard = generalCards.concat(heroCards).find(x => x.id == newCardID)
                      if(addToCardsList)
                        cards.push(newCard)
                      setCard(newCard)
                      navigation.setParams({cardID: newCardID})
                    }}
                    closeCards={() => {
                      navigation.setParams({cardID: ''})
                    }}
                    returnToPreviousCard={returnToPreviousCard}
                    previousCardExists={(cards.length>1) ? true : false}
                  />
              </View>
            }
          </View>
          </>
        )
      }

export default CardListTab;
